<template>
  <div>
    <b-button
      variant="primary"
      class="upload-picture-button"
      @click="upload_picture = true"
    >
      <i class="fa fa-camera" aria-hidden="true"></i>
    </b-button>
    <b-modal
      title="Update Picture"
      class="modal-primary"
      v-model="upload_picture"
      @ok="uploadPic(), (upload_picture = false)"
    >
      <croppa
        class="image-crop"
        style="border-radius: 50%"
        v-model="myCroppa"
        :prevent-white-space="true"
        remove-button-color="grey"
        :placeholder-font-size="15"
      />
    </b-modal>
  </div>
</template>

<script>
import "vue-croppa/dist/vue-croppa.css";
import Vue from "vue";
import Croppa from "vue-croppa";
Vue.use(Croppa);

export default {
  name: "UpdatePicture",
  props: ["userId"],
  data: function () {
    return {
      upload_picture: false,
      myCroppa: null,
    };
  },
  methods: {
    uploadPic() {
      this.myCroppa.generateBlob(
        (blob) => {
          let formData = new FormData();
          formData.append("img", blob, "profilePicture-" + this.userId);
          formData.append("userId", this.userId);
          this.$http
            .post("api/profile/updatePicture.php", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(
              (res) => {
                console.log(res.data);
                localStorage.setItem(
                  `${this.$company}_user_picture`,
                  res.data.Image
                );
                this.$emit("picChanged", res.data.Image);
              },
              (err) => {
                console.log(err);
              }
            );
        },
        "image/jpeg",
        0.8
      );
    },
  },
};
</script>

<style>
.croppa-container {
  display: block !important;
  margin: auto;
  width: 45vh;
  height: 45vh;
}
.croppa-container canvas {
  border-radius: 50%;
  width: 45vh !important;
  height: 45vh !important;
  display: block;
  margin: auto;
}
.upload-picture-button {
  border-radius: 50%;
  height: 50px;
  width: 50px;
}
</style>
